<template>
  <div class="main-content">
    <div class="modal" tabindex="-1" role="dialog" id="cancelUserSentModal">
      <div class="modal-dialog" role="document">
        <div class="modal-content" v-if="cancelUserSent.id">
          <div class="modal-header">
            <h5 class="modal-title">Cancelar envio de {{ cancelUserSent.user.name }}</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-md-12">
                <div class="form-group">
                  <label>Motivo:</label>
                  <textarea class="form-control" rows="4" v-model="cancelReason"></textarea>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancelar</button>
            <button type="button" @click="cancel(cancelUserSent)" class="btn btn-danger">Confirmar</button>
          </div>
        </div>
      </div>
    </div>
    <!-- Filters -->
    <div class="row">
      <div class="col-md-12">
        <div class="card">
          <div class="card-header">
            <div
              class="card-title"
              data-toggle="collapse"
              data-target="#collapseFilter"
              role="button"
              aria-expanded="false"
              aria-controls="collapseFilter"
              style="cursor: pointer;"
            >
              Filtros
              <button
                class="btn btn-inform"
                data-toggle="collapse"
                data-target="#collapseFilter"
                role="button"
                aria-expanded="false"
                aria-controls="collapseFilter"
              >
                <i class="fas fa-angle-down"></i>
              </button>
            </div>
          </div>

          <div class="collapse" id="collapseFilter">
            <div class="card-body">
              <div class="row">
                <div class="col-md-4">
                  <div class="form-group">
                    <label for="filterDateIn">Data Início</label>
                    <datetime
                      v-model="filters.dateStart"
                      class="form-control along"
                      :phrases="{ok: 'Ok', cancel: 'Cancelar'}"
                      value-zone="America/Sao_Paulo"
                      zone="America/Sao_Paulo"
                      v-on:input="getBatches()"
                    ></datetime>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="form-group">
                    <label for="filterDateEnd">Data Fim</label>
                    <datetime
                      v-model="filters.dateEnd"
                      class="form-control along"
                      :phrases="{ok: 'Ok', cancel: 'Cancelar'}"
                      value-zone="America/Sao_Paulo"
                      zone="America/Sao_Paulo"
                      v-on:input="getBatches()"
                    ></datetime>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="form-group">
                    <label for="filterCompany">Empresa</label>
                    <v-select
                      v-model="filters.company_id"
                      :options="companies"
                      :reduce="companies => companies.id"
                      label="fantasy_name"
                      class="style-chooser"
                      id="companies"
                      multiple
                      v-on:input="getBatches()"
                    >
                      <div slot="no-options">Nenhum registro encontrado.</div>
                    </v-select>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="form-group">
                    <label for="filterBranch">Unidade</label>
                    <v-select
                      v-model="filters.branch_id"
                      :options="filteredBranches"
                      :reduce="filteredBranches => filteredBranches.id"
                      label="name"
                      class="style-chooser"
                      id="branches"
                      multiple
                      v-on:input="getBatches()"
                    >
                      <div slot="no-options">Nenhum registro encontrado.</div>
                    </v-select>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="form-group">
                    <label for="filterSection">Departamento</label>
                    <v-select
                      v-model="filters.sector_id"
                      :options="filteredSectors"
                      :reduce="filteredSectors => filteredSectors.id"
                      label="name"
                      class="style-chooser"
                      id="sectors"
                      multiple
                      v-on:input="getBatches()"
                    >
                      <div slot="no-options">Nenhum registro encontrado.</div>
                    </v-select>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="form-group">
                    <label for="filterSection">Usuários</label>
                    <v-select
                      :options="users"
                      label="name"
                      :reduce="users => users.id"
                      class="style-chooser"
                      id="sectors"
                      multiple
                      v-model="filters.user_id"
                      v-on:input="getBatches()"
                    >
                      <div slot="no-options">Nenhum registro encontrado.</div>
                    </v-select>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-md-12">
        <div class="card">
          <div class="card-header">
            <div class="card-title">Gerenciamento de Assinaturas</div>
          </div>
          <div class="card-body">
            <div class="row">
              <!-- <div class="col-md-6">
                <div class="form-group">
                  <input
                    type="text"
                    class="form-control along"
                    id="filterSearch"
                    placeholder="Palavra chave..."
                    v-model="filters.docto"
                    @keyup="getBatches"
                  />
                </div>
              </div>-->
            </div>
            <div class="row">
              <div class="col-md-12">
                <p class="mb-3">Filtre pelo status dos documentos:</p>
              </div>
              <div class="col-md-3">
                <input
                  type="checkbox"
                  value="1"
                  v-model="filters.signed"
                  @change="getBatches()"
                  id="signed"
                  name="signed"
                />
                <label for="signed">
                  <i class="fas fa-file-contract" style="margin-left: 10px; margin-right: 10px;"></i> Assinado
                </label>
              </div>
              <div class="col-md-3">
                <input
                  type="checkbox"
                  v-model="filters.pending"
                  value="1"
                  @change="getBatches()"
                  id="pending"
                  name="pending"
                />
                <label for="pending">
                  <i class="fas fa-file-contract" style="margin-left: 10px; margin-right: 10px;"></i> Pendente
                </label>
              </div>
              <div class="col-md-3">
                <input
                  type="checkbox"
                  v-model="filters.late"
                  value="1"
                  @change="getBatches()"
                  id="late"
                  name="late"
                />
                <label for="late">
                  <i class="fas fa-file-contract" style="margin-left: 10px; margin-right: 10px;"></i> Atrasado
                </label>
              </div>
              <div class="col-md-3">
                <input
                  type="checkbox"
                  v-model="filters.cancel"
                  value="1"
                  @change="getBatches()"
                  id="cancel"
                  name="cancel"
                />
                <label for="cancel">
                  <i class="fas fa-file-contract" style="margin-left: 10px; margin-right: 10px;"></i> Cancelado
                </label>
              </div>
            </div>
            <hr />
            <div class="row">
              <div class="col-md-12">
                <div class="table-responsive">
                  <table class="table table-hover">
                    <thead>
                      <tr>
                        <th scope="col" @click="setSort('id')">#ID</th>
                        <th scope="col">#ID do Lote</th>
                        <th scope="col">Nome Assinante</th>
                        <th scope="col">Empresa</th>
                        <th scope="col">Documento</th>
                        <th scope="col" @click="setSort('created_at')">Data Envio</th>
                        <th scope="col">Status</th>
                        <th scope="col" @click="setSort('view_counter')">Views</th>
                        <th scope="col">Ação</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="user_sent in batches" :key="user_sent.id">
                        <td>{{user_sent.id}}</td>
                        <td>{{user_sent.signature_batch_id}}</td>
                        <td>{{user_sent.user.name}}</td>
                        <td>{{user_sent.user.company.fantasy_name}}</td>
                        <td>{{user_sent.signature_batch.name}}</td>
                        <td>{{user_sent.sent_at}}</td>
                        <td>
                          <span
                            class="badge"
                            :class="[user_sent.status == 'done' ? 'pastel-green' : user_sent.status == 'pending' ? 'pastel-yellow' : 'pastel-red']"
                          >{{user_sent.status == 'done' ? 'Concluído' : user_sent.status == 'pending' ? 'Pendente' : user_sent.status == 'late' ? 'Atrasado' : 'Cancelado'}}</span>
                        </td>
                        <td>{{user_sent.view_counter}}</td>
                        <td>
                          <button
                            @click="iframe(user_sent.document_http)"
                            class="btn btn-crud view"
                            data-tooltip="tooltip"
                            title="Visualizar"
                          >
                            <i class="far fa-eye"></i>
                          </button>
                          <button
                            @click="det(user_sent)"
                            class="btn btn-crud edit"
                            data-tooltip="tooltip"
                            title="Visualizar"
                            v-if="user_sent.signed == 1"
                          >
                            <i class="fas fa-list"></i>
                          </button>
                          <button
                            v-if="!user_sent.canceled_at"
                            @click="cancelModal(user_sent)"
                            class="btn btn-crud delete"
                            data-tooltip="tooltip"
                            title="Cancelar"
                          >
                            <i class="fas fa-ban"></i>
                          </button>
                        </td>
                      </tr>
                      <tr v-if="batches.length == 0" align="center">
                        <td colspan="9">Nenhum registro encontrado.</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <pagination :records="total" :options="options" :per-page="10" @paginate="getBatches"></pagination>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal Documento -->
    <div
      class="modal fade"
      id="modalDocument"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">Visualização do Documento</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div>
            <iframe :src="document_http" class="iframe"></iframe>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal Detalhe Assinatura -->

    <div
      class="modal fade"
      id="modalDetail"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-lg" role="document">
        <div v-if="detail.user" class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">Detalhes da Assinatura</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="row content-detail">
            <div class="col-md-6" style="font-size: 16px;">
              <i class="fas fa-user"></i>
              &nbsp;Assinado por {{ detail.user.name }}
            </div>

            <div class="col-md-6" style="font-size: 16px">
              <i class="fas fa-calendar-check"></i>
              &nbsp;Assinado em {{ detail.signed_at }}
            </div>
          </div>
          <div class="row content-detail">
            <div class="col-md-6" style="font-size: 16px;">
              <i class="fas fa-globe-americas"></i>
              &nbsp;Assinado no IP {{ detail.users_signed[0].ip }}
            </div>
          </div>
          <div class="row content-detail">
            <div class="col-md-12" style="font-size: 16px">
              <i class="fas fa-map-marked-alt"></i>
              &nbsp;Geolocalização (Latitude: {{ detail.latitude }} | Longitude: {{ detail.longitude }})
            </div>
          </div>
          <div class="row content-detail">
            <div class="col-md-12">
              <iframe
                width="100%"
                height="250"
                frameborder="0"
                style="border:0"
                :src="src"
                allowfullscreen
              ></iframe>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Pagination } from "vue-pagination-2";
export default {
  data() {
    return {
      options: {
        texts: {
          count: "Mostrando {from} de {to} até {count} de registros"
        }
      },
      total: 0,
      document_http: "",
      src: "",
      detail: [],
      companies: [],
      branches: [],
      sectors: [],
      batches: [],
      users: [],
      filters: {
        dateStart: "",
        dateEnd: "",
        sector_id: "",
        branch_id: "",
        company_id: "",
        docto: "",
        pending: "",
        signed: "",
        late: "",
        cancel: "",
        sort: "",
        orientation: "",
        intern: ""
      },
      page: 2,
      orientation: "middle",
      cancelReason: "",
      cancelUserSent: ""
    };
  },
  computed: {
    filteredBranches: function() {
      var bcs = [];
      for (var i = 0; i <= this.filters.company_id.length; i++) {
        var b2 = this.branches.filter(
          x => x.company_id == this.filters.company_id[i]
        );
        bcs.push(b2[0]);
      }
      bcs.splice(i - 1);
      return bcs;
    },
    filteredSectors: function() {
      var scs = [];
      for (var i = 0; i <= this.filters.company_id.length; i++) {
        var c2 = this.sectors.filter(
          x => x.company_id == this.filters.company_id[i]
        );
        scs.push(c2[0]);
      }
      scs.splice(i - 1);
      return scs;
    }
  },
  methods: {
    cancelModal(userSent) {
      this.cancelUserSent = userSent;
      $("#cancelUserSentModal").modal("show");
    },
    cancel(userSent) {
      const self = this;
      const api =
        self.$store.state.api + "signatureusersents/cancel/" + userSent.id;
      const fd = new FormData();
      fd.append("cancel_reason", self.cancelReason);
      self.$http
        .post(api, fd)
        .then(response => {
          self.getBatches();
          $("#cancelUserSentModal").modal("hide");
          self.$message("Sucesso", "Envio cancelado com sucesso", "success");
        })
        .catch(error => {
          self.$message("Erro", error.response.data, "error");
        });
    },
    iframe(url) {
      this.document_http = url;
      $("#modalDocument").modal();
    },
    det(det) {
      this.detail = det;
      this.src =
        "https://www.google.com/maps/embed/v1/place?key=AIzaSyAVReyDOd0JcVSHy1CvERGbMXbqA1pkiZA&q=" +
        this.detail.latitude +
        "," +
        this.detail.longitude +
        "&zoom=18&maptype=roadmap";
      $("#modalDetail").modal();
    },
    setSort(id, intern = null) {
      this.orientation =
        this.orientation == "desc"
          ? (this.orientation = "asc")
          : (this.orientation = "desc");
      this.filters.sort = id;
      this.filters.intern = intern;
      this.filters.orientation = this.orientation;
      this.getBatches();
    },
    getCompanies: function() {
      const self = this;
      const api =
        self.$store.state.api + "companies?paginated=false&with[]=branches";
      self.$http
        .get(api)
        .then(response => {
          self.companies = response.data.data;
        })
        .catch(error => {
          self.$message("Erro", error.response.data, "error");
        });
    },
    getBranches: function() {
      const self = this;
      const api = self.$store.state.api + "branches?paginated=false";
      self.$http
        .get(api)
        .then(response => {
          self.branches = response.data.data;
        })
        .catch(error => {
          self.$message("Erro", error.response.data, "error");
        });
    },
    getSectors: function() {
      const self = this;
      const api = self.$store.state.api + "sectors?paginated=false";
      self.$http
        .get(api)
        .then(response => {
          self.sectors = response.data.data;
        })
        .catch(error => {
          self.$message("Erro", error.response.data, "error");
        });
    },
    getUsers: function() {
      const self = this;
      const api = self.$store.state.api + "users?paginated=false";
      self.$http
        .get(api)
        .then(response => {
          self.users = response.data.data;
        })
        .catch(error => {
          self.$message("Erro", error.response.data, "error");
        });
    },
    getBatches: function(page = null, sort = null) {
      const self = this;
      const api =
        self.$store.state.api +
        "signature_management_signatures?page=" +
        (page ? page : 1);
      self.$http
        .post(api, {
          filters: self.filters
        })
        .then(response => {
          self.batches = response.data.data;
          self.total = response.data.total;
        })
        .catch(error => {
          self.$message("Erro", error.response.data, "error");
        });
    }
  },
  mounted() {
    this.getCompanies();
    this.getBranches();
    this.getSectors();
    this.getUsers();
    this.getBatches();
  },
  components: { Pagination }
};
</script>
<style scoped>
.content-detail {
  padding: 20px;
}
.date-time-picker .field-input[data-v-74507c40] {
  border: none;
  border-bottom: 2px solid #03a830;
  color: #03a830;
}
.along {
  height: 40px;
}

input[type="checkbox"] {
  position: absolute;
  z-index: -1;
  opacity: 0;
}

input[type="checkbox"] + label {
  font-size: 12px;
  padding: 2px 0 0;
  width: 100px;
  height: 25px;
  border: 2px solid #28a745;
  color: #424241;
  border-radius: 0.25rem;
}
input[type="checkbox"]:checked + label {
  border: 2px solid #03a830;
  color: #fff;
  background-color: #03a830;
  font-style: normal;
}

.iframe {
  width: 100%;
  height: 700px;
}
</style>


// WEBPACK FOOTER //
// src/components/SignatureBatch/Management/Signatures.vue